import React from 'react';

import MenuIcon from 'react-icons/lib/md/menu';
import './index.css';

const Home = () => (
  <div className="home-page">
    <h1>Welcome</h1>
    <div>
      <p>
        Press the <MenuIcon /> icon to begin.
      </p>
    </div>
  </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/components/pages/home/index.jsx